export { WORD_LIST_COLLECTION, PAGE_GROUPS, PAGES } from "./pagesConsts";

export {
	AD_LAYOUTS,
	AD_LAYOUT_STUBS,
	AD_PAGETYPES,
	AD_PLACEMENTS,
	AD_POSITIONS,
} from "./adConsts";

export { COUNTRIES } from "./countriesConsts";

export { DICTIONARIES, DICTIONARIES_IN_API } from "./dictionariesConsts";

export { LANG_EN, SITE_LANGUAGE } from "./languageConsts";

export {
	YDR_PROTOCOL,
	WF_PROTOCOL,
	CANONICAL_PROTOCOL,
	YDR_URL,
	API_SERVICE,
	API_SERVICE_AUTH,
	SAVEDWORDS_KEYNAME,
	DICTIONARY_KEYNAME,
	DEFAULTWORDS_COOKIENAME,
	VERSION_CHECK_POLL_FREQ,
	VERSION_CHECK_ERROR,
	CANONICAL_HOST,
	TRANSLATIONS_READY,
	NEWSLETTERS,
} from "./networkConsts";

export {
	UNSCRAMBLER_MIN_LENGTH,
	UNSCRAMBLER_MAX_LENGTH,
	UNSCRAMBLER_MAX_WILDCARDS,
	API_MAX_RESULTS,
	DEFAULT_WORDLENGTH,
	DEFAULT_EXACTMATCH,
	ASC,
	DESC,
	DEFAULT_TABLE_SORTING,
	GAME_TYPES,
	SORT_RESULTS_OPTIONS,
	DEFAULT_SORT_RESULTS,
	WORDS,
	SCORES,
	SORT_RESULTS_KEYNAME,
	FILTER_KEYNAME,
	DIGRAPHS,
} from "./searchConsts";

export { TRACKER_DATA, TRACKER_SETTINGS } from "./trackersConsts";

export {
	STICKY_AD_TOP_GAP,
	SMALL_DEVICE_WIDTH_MAX,
	MEDIUM_PORTRAIT_WIDTH_MAX,
	MEDIUM_DEVICE_WIDTH_MAX,
	LARGE_DEVICE_WIDTH_MAX,
	TOUCH_DEVICE_HEADER_HEIGHT,
	DESKTOP_HEADER_HEIGHT,
} from "./windowConsts";

export const TRANSPARENT_PNG =
	"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII="; // Transparent PNG
